class ToolbarController {
  constructor(Auth) {
  	this.Auth = Auth;
    this.name = 'toolbar';
  }

  logout() {
  	this.Auth.logout();
  }
}

ToolbarController.$inject = ['Auth'];

export default ToolbarController;



// WEBPACK FOOTER //
// ./client/app/common/layout/toolbar/toolbar.controller.js